import { render } from "./InstitutionalStatistics.vue?vue&type=template&id=2ac9c3c8&scoped=true"
import script from "./InstitutionalStatistics.vue?vue&type=script&lang=ts"
export * from "./InstitutionalStatistics.vue?vue&type=script&lang=ts"

import "./InstitutionalStatistics.vue?vue&type=style&index=0&id=2ac9c3c8&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2ac9c3c8"

export default script